import { useEffect, useState } from "react";

import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";

import { i18n } from "services/i18nService";
import { get } from "services/sosInventoryService/sosApi";
import { handleProgramError } from "services/utility/errors";

import { OBJECT_TYPES } from "appConstants";

const objectType = OBJECT_TYPES.UPS_ACCOUNT.fullString;

export function FrmUpsAccount(props) {
  const { value, onValueChange, error } = props;
  const [upsAccounts, setUpsAccounts] = useState(null);

  useEffect(() => {
    async function retrieveRecords() {
      const { success, data, message } = await get(objectType, {
        inTransaction: true,
      });
      if (success) {
        setUpsAccounts(
          data.records.map(({ number, description }) => ({
            id: number,
            name: `${number} (${description})`,
          }))
        );
      } else {
        handleProgramError(
          new Error(
            `FrmUpsAccount | unsuccessful call to get, message: ${message}`
          )
        );
      }
    }
    retrieveRecords();
  }, []);

  return (
    <FrmSelectFromObjects
      disableClearable
      name="upsAccount"
      label={i18n("frmLabel.UpsAccount")}
      value={value}
      onValueChange={onValueChange}
      options={upsAccounts}
      error={error}
    />
  );
}
